module.exports = __webpack_public_path__ + "static/media/NOBA_NBYAA.f114eae0.svg";